import ZkTag from './src/tag';

/* istanbul ignore next */
ZkTag.install = function(Vue) {
  Vue.component(ZkTag.name, ZkTag);
};

export default ZkTag;



// WEBPACK FOOTER //
// ./src/packages/tag/index.js